import type { ViewModel } from "./ViewModel";

export default function getViewModelNewValues(): ViewModel {
  return {
    isConsumerOrPrivilegedEntrepreneurConfirmed: false,
    invoice: null,
    items: [],
    comments: "",
  };
}
